module.exports = "/assets/data/d7c7d70d74e26ecb532d245cf422b7f9-E7.data.json";